import(/* webpackMode: "eager", webpackExports: ["useUser"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/hooks/use-user.js");
;
import(/* webpackMode: "eager", webpackExports: ["Auth0Provider"] */ "/home/will/Documents/Business/wise/repos/wise/node_modules/@auth0/nextjs-auth0/dist/client/providers/auth0-provider.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Tracked"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/analytics/components/Tracked.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserTracked"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/analytics/components/UserTracked.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/consent/components/Termly.tsx");
